import UniversityDashboard from "../dashboard/UniversityDashboard";

import { Container } from "components/ui-kit/styled-templates";

const UniDashboardPage = (props) => {
    return (
        <Container extra="form { width: 100%; margin: 30px 0; }">
            <UniversityDashboard />
        </Container>
    );
};

export default UniDashboardPage;
